<template>
    <div>
        <div v-if="selectedName" class="mb-5">
            {{ __('Kiválasztva') }}: {{ selectedName }}
        </div>

        <div v-if="dpdInitCountryName">
            <iframe frameborder="0" loading="lazy" :src="'https://cdn.pudofinder.dpd.hu/index.html?lang=en&locker=1&single=1&country=' + dpdInitCountryName" width="100%" height="800px"></iframe>
        </div>

        <div v-else>
            <iframe frameborder="0" loading="lazy" src="https://cdn.pudofinder.dpd.hu/index.html?lang=en&locker=1" width="100%" height="800px"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DpdParcelLocker',

    props: {
        pickupPoint: {
            default: null
        },
    },

    data() {
        return {
            selectedName: null,
            dpdInitCountryName: window.dpdInitCountryName,
            dpdInitCountryCode: window.dpdInitCountryCode,
        }
    },

    created() {
        window.addEventListener('message', this.receiveMessage, false);
    },

    methods: {
        receiveMessage(event) {
            var apt = JSON.parse(event.data)

            if (this.dpdInitCountryCode && ! apt.id.startsWith(this.dpdInitCountryCode)) {
                alert('A kiválasztott pont nem érhető el ebből az országból: ' + this.dpdInitCountryCode)
                return
            }

            this.selectedName = apt.address + ' (' + apt.name + ')'
            this.$emit('input', apt)
        },
    },
}
</script>
